export type CollectionWho =
  | 'Public crews'
  | 'Open market'
  | 'Publicly selected contractor(s)'
  | 'Other'
  | 'Publicly selected franchised hauler(s)';


export const COLLECTION_WHOS: CollectionWho[] = [
  'Public crews',
  'Open market',
  'Publicly selected contractor(s)',
  'Publicly selected franchised hauler(s)',
  'Other',
];
